import React, { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import html2canvas from "html2canvas";
import "./DesignGenerator.css";
import cameraLineart from "../../assets/images/camera-lineart.png";
import cameraSmall from "../../assets/images/camera-small.png";
import logoSnap from "../../assets/images/logoSnapOk.png";

const DesignGenerator = ({ eventUrl, albumOf, eventDate, eventType = "wedding" }) => {
  const cartelRef = useRef(null);
  const invitacionRef = useRef(null);
  const miraRef = useRef(null);

  const downloadDesign = async (ref, filename) => {
    if (!ref.current) return;
    try {
      const canvas = await html2canvas(ref.current, {
        scale: 3,
        useCORS: true,
        backgroundColor: null,
      });
      const link = document.createElement("a");
      link.download = `${filename}.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();
    } catch (err) {
      console.error("Error generating design:", err);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr + "T12:00:00");
    const months = [
      "Enero","Febrero","Marzo","Abril","Mayo","Junio",
      "Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre",
    ];
    return `${d.getDate()} de ${months[d.getMonth()]} de ${d.getFullYear()}`;
  };

  const weddingItems = [
    "Una foto grupal de tu mesa",
    `Primer baile de ${albumOf}`,
    "La entrada a la fiesta",
    "El outfit más original",
    "El mejor bailarín",
    "Una cara graciosa",
    "Alguien dando un discurso",
    "Alguien tomando un trago",
    "El momento del ramo",
    "Gente riendo",
    "Un momento tierno",
    "¡Una foto de vos!",
  ];

  const xvItems = [
    "Una foto grupal con tus amigos",
    `La entrada de ${albumOf}`,
    "El primer baile",
    "El outfit más original",
    "El mejor bailarín de la noche",
    "Una cara graciosa",
    "Alguien con un trago divertido",
    "Gente riendo",
    "Un momento tierno",
    "¡Una foto tuya!",
    "La comida más tentadora",
    "Alguien sacándose una selfie",
  ];

  const items = eventType === "wedding" ? weddingItems : xvItems;

  return (
    <div className="design-generator">
      <h2>Diseños para tu evento</h2>
      <p className="design-generator__sub">
        Descargá los diseños listos para enviar a tus invitados.
      </p>

      {/* === CARTEL (Poster with camera + QR) === */}
      <div className="design-generator__section">
        <h3>Cartel</h3>
        <div className="design-generator__preview">
          <div ref={cartelRef} className="design--cartel">
            <div className="design--cartel__header">
              <span className="design--cartel__capture">CAPTURE</span>
              <span className="design--cartel__and">&amp; SHARE</span>
              <span className="design--cartel__love">the love</span>
            </div>
            <div className="design--cartel__camera">
              <img src={cameraLineart} alt="" className="design--cartel__camera-img" />
              <div className="design--cartel__qr-overlay">
                <QRCodeCanvas value={eventUrl} size={120} bgColor="transparent" fgColor="#000" level="M" />
              </div>
            </div>
            <p className="design--cartel__cta">SUBÍ TUS FOTOS</p>
            <p className="design--cartel__desc">
              Escaneá el código QR con tu celular. ¡Capturá fotos
              ilimitadas y compartilas durante toda la fiesta!
            </p>
            <p className="design--cartel__names">{albumOf}</p>
            <p className="design--cartel__date">{formatDate(eventDate)}</p>
          </div>
        </div>
        <button className="design-generator__download" onClick={() => downloadDesign(cartelRef, `cartel-${albumOf || "evento"}`)}>
          <i className="fas fa-download"></i> Descargar Cartel
        </button>
      </div>

      {/* === INVITACIÓN (Square Instagram post) === */}
      <div className="design-generator__section">
        <h3>Invitación Digital</h3>
        <div className="design-generator__preview">
          <div ref={invitacionRef} className="design--invitacion">
            <p className="design--invitacion__headline">Subí tus<br/>Fotos</p>
            <p className="design--invitacion__body">
              Escaneá el código QR con tu celular.
              ¡Capturá fotos ilimitadas y compartilas
              durante toda la fiesta!
            </p>
            <div className="design--invitacion__bottom">
              <div className="design--invitacion__info">
                <p className="design--invitacion__thanks">¡Gracias por estar!</p>
                <p className="design--invitacion__names">{albumOf}</p>
              </div>
              <div className="design--invitacion__qr">
                <QRCodeCanvas value={eventUrl} size={110} bgColor="transparent" fgColor="#000" level="M" />
              </div>
            </div>
            <div className="design--invitacion__brand">
              <img src={logoSnap} alt="Snap Moments" className="design--invitacion__logo" />
            </div>
          </div>
        </div>
        <button className="design-generator__download" onClick={() => downloadDesign(invitacionRef, `invitacion-${albumOf || "evento"}`)}>
          <i className="fas fa-download"></i> Descargar Invitación
        </button>
      </div>

      {/* === MIRÁ Y ENCONTRÁ / CAPTURE THE MOMENT === */}
      <div className="design-generator__section">
        <h3>{eventType === "wedding" ? "Mirá y Encontrá" : "Capture the Moment"}</h3>
        <div className="design-generator__preview">
          <div ref={miraRef} className="design--mira">
            {eventType === "wedding" ? (
              <p className="design--mira__title-script">Mirá y Encontrá</p>
            ) : (
              <div className="design--mira__title-xv">
                <span className="design--mira__capture">CAPTURE</span>
                <span className="design--mira__the">the</span>
                <span className="design--mira__moment">MOMENT</span>
              </div>
            )}

            <p className="design--mira__intro">
              USÁ TU CÁMARA Y MIRÁ A TU ALREDEDOR, ¡BUSCÁ ESOS MOMENTOS ÚNICOS QUE PODÉS
              CAPTURAR! COMPLETÁ LA LISTA Y SUBÍ LAS FOTOS AL ÁLBUM PARA RECORDARLOS POR SIEMPRE.
            </p>

            <div className="design--mira__divider"></div>

            <ul className="design--mira__list">
              {items.map((item, i) => (
                <li key={i}>
                  {eventType === "wedding" ? "♡" : "☐"} {item}
                </li>
              ))}
            </ul>

            <div className="design--mira__footer">
              <div className="design--mira__footer-left">
                <p className="design--mira__share">¡Compartí<br/>tus fotos<br/>con<br/>nosotros!</p>
                <p className="design--mira__gracias">Gracias</p>
              </div>
              <div className="design--mira__footer-right">
                <div className="design--mira__qr-wrapper">
                  <QRCodeCanvas value={eventUrl} size={70} bgColor="transparent" fgColor="#000" level="M" />
                  <img src={cameraSmall} alt="" className="design--mira__camera-small" />
                </div>
              </div>
            </div>

            <div className="design--mira__names-bar">
              <span>{albumOf?.toUpperCase()}</span>
            </div>
          </div>
        </div>
        <button className="design-generator__download" onClick={() => downloadDesign(miraRef, `mira-encontra-${albumOf || "evento"}`)}>
          <i className="fas fa-download"></i> Descargar {eventType === "wedding" ? "Mirá y Encontrá" : "Capture the Moment"}
        </button>
      </div>
    </div>
  );
};

export default DesignGenerator;